// extracted by mini-css-extract-plugin
export default {"timeline":"styles-module__timeline___gtxcS"};